{
  "version": 1,
  "asset_id": "7470871b-8b61-4468-945a-3d417e73b3da",
  "project_id": "7d1776ab-cb36-43c5-a7cd-acaad4e00de7",
  "url": "/__l5e/assets-v1/7470871b-8b61-4468-945a-3d417e73b3da/OP2P-CRM-e-Agentes-de-IA-logotipo-colorido-2026.webp",
  "r2_key": "a/v1/7d1776ab-cb36-43c5-a7cd-acaad4e00de7/7470871b-8b61-4468-945a-3d417e73b3da/OP2P-CRM-e-Agentes-de-IA-logotipo-colorido-2026.webp",
  "original_filename": "OP2P-CRM-e-Agentes-de-IA-logotipo-colorido-2026.webp",
  "size": 35038,
  "content_type": "image/webp",
  "created_at": "2026-08-31T20:14:42Z"
}
